import React from 'react';
import {Typography, useTheme} from '@creditas-ui/react';

export const FormHeader = (): JSX.Element => {
  const theme = useTheme() as any;
  
  return (
    <>
      <Typography
        marginBottom="16px"
        variant={{ '2xl': 'headingXlLight', _: 'headingMdLight' }}
        color="neutral.90"
      >
        Obtén tu auto a crédito
      </Typography>
      <Typography variant="bodyMdRegular" color="neutral.80">
        Aprovecha nuestra alianza con{' '}
        <strong style={{ fontWeight: 600, color: theme.colors.neutral['90']}}>Mercado Libre</strong> y consigue tu próximo coche.
      </Typography>
    </>
  );
};
